<!-- <div class="text-center">
	<input class="form-control" type="file"
			(change)="onChange($event)">

	<button (click)="onUpload()"
		class="btn btn-success">
		Upload
	</button>
</div> -->

<!-- Shareable short link of uploaded file -->
<!-- <div class="container text-center jumbotron" *ngIf="shortLink">
	<h2> Visit Here</h2>
	<a href="{{shortLink}}">{{shortLink}}</a>
</div> -->

<!--Flag variable is used here-->


<!-- Multi  -->
<div class="col-12" style="height: 100%;">
	<form class="dropzone needsclick dz-clickable p-0 upload-component" id="dropzone-multi">
		<app-loading-panel *ngIf="loading" class="app-loading-panel"></app-loading-panel>
		<div class="dz-message needsclick upload-font zero-pad text-center">
			<!-- {{ 'fileDrop.uploadText' | translate }} -->
			<i class="fa fa-plus plus-icon"></i>
		</div>
		<div class="fallback">
			<input name="file" type="file" class="upload-input" (change)="onUpload($event)">
		</div>
		<div>
			<div class="border border-2 rounded-3 preview-card p-2" *ngIf="shortLink">
				<!-- <img [attr.src]="shortLink" class="preview-img"> -->
				<i class='bx bxs-trash bx-tada icon-size'></i>
				<div class="remove-btn rounded-3">
					<button class="hidden" (click)="remove()">
						<i class='bx bxs-trash bx-tada icon-size'></i>
					</button>
				</div>
			</div>
		</div>
		<!-- <a href="{{shortLink}}" class="mt-1 preview-link" *ngIf="shortLink" target="_blank">{{shortLink}}</a> -->
	</form>
</div>
<!-- Multi  -->